import ngoPdfPrinter from '@/services/utils/ngoPdfPrinter';
import handleBarcode from "@/services/modules/barcode";
import handleCompany from "@/services/modules/company";
import { useVoucherPrint } from "@/services/utils/voucherPrint";

const pdfPrinterHelper = () => {
    const { exportToPDF } = ngoPdfPrinter();
    const { fetchBarcode } = handleBarcode();
    const { fetchCompanyInfo } = handleCompany();
    const { buildQrcodeText } = useVoucherPrint();
    var barcode = '', qrcode = '';
    var company = {};

    const generatePdf = (companyId, data, btnFunc, customizationPdfFields = []) => {
        let qrcodeData = buildQrcodeText(data);
        var barCodeQuery = `?code=${encodeURIComponent(data.voucher_no)}&qrcode=${encodeURIComponent(qrcodeData)}`;

        fetchBarcode(barCodeQuery).then( (res) => {
            barcode = res.barcode;
            qrcode = res.qrcode;
        }).then(() => {
            fetchCompanyInfo(companyId).then((res) => {
                company = res.data
            }).then(() => {
                exportToPDF(company, data, barcode, qrcode, btnFunc, customizationPdfFields)
            })
        })
    }

    return{
        generatePdf
    }
}

export default pdfPrinterHelper;